import { useSlate } from 'slate-react';

import { Editor } from 'slate';

import { ToggleGroup, ToggleGroupItem } from '../../lib/toggle-group.jsx';
import { editorControlButtons } from './TextAreaWithControls.constants.jsx';

const FormatButtonControls = ({ isDisabled }: { isDisabled: boolean }) => {
  const editor = useSlate();

  const isMarkActive = (format: string) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format as keyof typeof marks] === true : false;
  };

  const toggleMark =
    (mark: 'bold' | 'italic' | 'underline' | 'linethrough') => () => {
      const isActive = isMarkActive(mark);
      if (isActive) {
        Editor.removeMark(editor, mark);
      } else {
        Editor.addMark(editor, mark, true);
      }
    };

  return (
    <div className="bg-ui-primary">
      <ToggleGroup type="single">
        {editorControlButtons.map(({ role, value: formatValue, icon }) => {
          if (role === 'markButton') {
            return (
              <ToggleGroupItem
                key={formatValue}
                icon
                value={formatValue}
                disabled={isDisabled}
                role="format-button"
                data-state={isMarkActive(formatValue) ? 'on' : 'off'}
                aria-pressed={isMarkActive(formatValue)}
                onMouseDown={(e) => {
                  e.preventDefault();
                  toggleMark(
                    formatValue as
                      | 'bold'
                      | 'italic'
                      | 'underline'
                      | 'linethrough',
                  )();
                }}
              >
                {icon}
              </ToggleGroupItem>
            );
          }
        })}
      </ToggleGroup>
    </div>
  );
};

export default FormatButtonControls;
